import { queryOptions } from '@tanstack/react-query';
import { getNotificationsAction } from '@/features/notifications/presentation/actions/get-notifications';

export const notificationsKeys = {
  all: ['notifications'] as const,
  list: (locationUuid: string | undefined) => [...notificationsKeys.all, locationUuid] as const,
};

export const notificationsQueryOptions = (locationUuid: string | undefined) =>
  queryOptions({
    queryKey: notificationsKeys.list(locationUuid),
    queryFn: () => getNotificationsAction(locationUuid!),
    enabled: !!locationUuid,
  });
